import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInverterStatusIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 18,
	fill: "currentColor",
	viewBox: "0 0 32 21",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M30.5608 16.9965L30.5608 4.16049C30.5608 2.816 29.4709 1.72607 28.1264 1.72607L3.48709 1.72607C2.1426 1.72607 1.05267 2.816 1.05267 4.16049L1.05267 16.9965C1.05267 18.341 2.1426 19.4309 3.48709 19.4309L28.1264 19.4309C29.4709 19.4309 30.5608 18.341 30.5608 16.9965Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeWidth: 1.99747
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.77393 7.11646L7.80261 7.11646L9.83129 7.11646",
			stroke: "white",
			strokeWidth: 1.4981,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.77393 18.1047L11.0067 14.7273L26.9556 3.34608",
			stroke: "white",
			strokeWidth: 1.4981,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1182 12.3118C21.4357 12.6794 22.7058 13.5085 23.3564 12.3118C23.6584 11.5739 23.6442 10.6801 24.7953 10.7478C25.9464 10.8154 25.7083 11.6263 26.2342 12.3118C26.5162 12.6794 27.5687 13.175 28.4214 12.1266",
			stroke: "white",
			strokeWidth: 1.4981,
			strokeLinecap: "round"
		})
	]
});
export default SvgInverterStatusIcon;
